module.exports = __webpack_public_path__ + "static/pikabu-ae228e39c6ce64bb339563420e992e32.png";